import React from 'react';
import PropTypes from 'prop-types';

import I18nActionCreator from 'actions/I18nActionCreator';
import PreferenceActionCreator from 'actions/PreferenceActionCreator';
import Locale from 'utils/Locale';
import { Dropdown } from 'semantic-ui-react';

class LanguagePicker extends React.Component {
  static propTypes = {
    accountState: PropTypes.shape({
      account: PropTypes.shape({
        customerId: PropTypes.string,
      }),
    }).isRequired,
    className: PropTypes.string,
    i18nState: PropTypes.shape({
      currentLocale: PropTypes.string,
    }).isRequired,
    weblabs: PropTypes.objectOf(PropTypes.bool).isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  onLanguageChange = (event, { value: locale }) => {
    event.preventDefault();
    const { accountState } = this.props;
    if (accountState && accountState.account && accountState.account.customerId) {
      const { customerId } = accountState.account;
      PreferenceActionCreator.updatePreference(customerId, { locale });
    }
    I18nActionCreator.changeLocale(locale);
  }

  render() {
    const { className, i18nState: { currentLocale }, weblabs } = this.props;
    const { getString } = this.context;

    const options = Locale.getAvailableLocales(weblabs).map(locale => ({
      text: getString(Locale.buildNativeLocaleStringId(locale)),
      value: locale,
    }));

    /* TODO: Remove the parent div and simply return a <Dropdown> component */
    return (
      <div className={className}>
        <Dropdown
          className="aa-nav-dropdown aa-nav-link"
          inline
          options={options}
          value={currentLocale}
          pointing="top right"
          onChange={this.onLanguageChange}
          selectOnNavigation={false}
        />
      </div>
    );
  }
}

export default LanguagePicker;
